import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { pushReturnsEvent } from "../../data-layer/data-layer/returns.js";
import { createFieldIds } from "../../utils/utils/create-field-ids.js";
import { getReturnReason } from "../../utils/utils/get-return-reason.js";
import { useCreateReturn } from "./use-create-return.js";
const decapitalizeFirstLetter = (str) => str.charAt(0).toLowerCase() + str.slice(1);
const useReturnSubmission = ({
  email,
  orderNumber,
  lineItems,
  returnReasons
}) => {
  const linkResult = useLink({
    route: "returns.confirmation",
    params: { email, orderNumber }
  });
  const navigateToConfirmation = linkResult?.onClick;
  const handleCompleted = React.useCallback(
    (response) => {
      if (response.createReturn.failures && response.createReturn.failures.length === 0) {
        navigateToConfirmation?.();
      } else {
        const errorMessages = response.createReturn.failures.map((error) => {
          if (error.__typename) {
            return `returns.errors.${decapitalizeFirstLetter(
              error.__typename.replace("Failure", "")
            )}.message`;
          }
          return "returns.returnGeneralFailure.message";
        });
        errorMessages.forEach((errorMessage) => {
          toast.failed(errorMessage);
        });
      }
    },
    [navigateToConfirmation]
  );
  const handleError = React.useCallback(() => {
    toast.failed("returns.returnGeneralFailure.message");
  }, []);
  const [trigger, { loading }] = useCreateReturn({
    onCompleted: handleCompleted,
    onError: handleError
  });
  const submit = React.useCallback(
    async (formState) => {
      const onlySelectedItems = (id) => {
        const inputNames = createFieldIds(`${id}`);
        const checkbox = formState[inputNames.checkbox];
        return lineItems.length > 1 ? checkbox === "true" : true;
      };
      const inputItems = lineItems.map((lineItem, index) => {
        const inputNames = createFieldIds(`${index}`);
        const reasonText = getReturnReason(returnReasons, inputNames, formState);
        return {
          quantity: Number(formState[inputNames.quantity]) || 1,
          reason: formState[inputNames.reason] ?? "",
          reasonText: reasonText ?? "",
          sku: lineItem.sku,
          lineItemNumber: lineItem.lineItemNumber || 0
        };
      }).filter((_, index) => onlySelectedItems(index));
      if (inputItems.length > 0) {
        pushReturnsEvent({
          interactionType: "confirm_return",
          items: inputItems.map((item, index) => ({
            ...item,
            name: lineItems[index]?.displayName ?? ""
          }))
        });
        await trigger({
          email,
          orderNumber,
          lineItems: inputItems
        });
      }
    },
    [email, lineItems, orderNumber, returnReasons, trigger]
  );
  return { submit, loading };
};
export {
  useReturnSubmission
};
//# sourceMappingURL=use-return-submission.js.map
